;(() => {
  let rootOffset = null
  let usages = 0

  const style = document.querySelector(".body-inner")?.style

  function saveOffset() {
    if (usages === 0) {
      rootOffset = window.pageYOffset
      window.scrollTo(0, 0)

      if (style) {
        style.transform = `translateY(-${rootOffset}px)`
      }
    }

    usages++
  }

  function restoreOffset() {
    if (usages === 1) {
      if (style) {
        style.transform = ""
      }

      window.scrollTo(0, rootOffset)
    }

    usages--
  }

  window.HB ??= {}
  window.HB.controlOffset = { saveOffset, restoreOffset }
})()
